<template>
  <MainPage />
</template>

<script>
import MainPage from '@/components/main-page/index.vue'

export default {
  name: 'Main',
  components: { MainPage }
}
</script>

<style scoped>

</style>
